import isMobile from '../utils/isMobile';

const emailOrCallHome = () => {
  if (isMobile()) {
    // Tyler's cell phone!
    window.location.href = 'tel:6172376914';
  } else {
    window.location.href = 'mailto:sales@gofisherman.com';
  }
}

const getEmailOrCallText = () => isMobile() ? 'Call Sales' : 'Email Sales';

export { emailOrCallHome, getEmailOrCallText };
